
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/term-of-services",
      function () {
        return require("private-next-pages/term-of-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/term-of-services"])
      });
    }
  